<template>
  <v-card
      flat
      class="mx-auto"
      max-width="800"
      mim-width="350">
    <v-card flat class="mx-auto">
      <div class="mx-auto text-center">
        <img height="300" class="w-100 h-auto" :src="getRealImgPath(menu.image_path)" @error="getImage">
      </div>

      <v-breadcrumbs :items="tags" class="text-grey-darken-2 font-weight-bold text-body-2" densit="compact">
        <template v-slot:divider>/</template>
        <template v-slot:title="{ item }">
          {{ item.title }}
        </template>
      </v-breadcrumbs>

      <v-card-text class="pa-1 pl-3 pr-3 text-body-1 font-weight-bold">
        {{ menu.menu_name }}
      </v-card-text>
<!--      <v-card-subtitle class="pa-1 pl-3 pr-3">-->
<!--        {{ menu.menu_notice }}-->
<!--      </v-card-subtitle>-->
      <v-card-text class="mt-2 pa-1 pl-3 pr-3 text-h6 font-weight-bold">
        {{ formatAmt(menu.sale_price) }}
      </v-card-text>
    </v-card>

    <v-card flat class="mx-auto mt-3">
      <v-card-text class="pa-1 pl-3 pr-3 text-body-1 font-weight-bold">
        상품안내
      </v-card-text>
      <v-card-text class="pa-1 pl-3 pr-3 text-body-2">
        <p class="editorHtml" v-html="menuCommentDtl"></p>
      </v-card-text>
    </v-card>

    <v-card flat class="mx-auto mt-3">
      <v-card-text class="pa-1 pl-3 pr-3 text-body-2 font-weight-bold">
        업장안내
      </v-card-text>
      <v-card-text class="pa-1 pl-3 pr-3 text-body-2">
        <p class="editorHtml" v-html="menu.upjang_notice || '-'"></p>
      </v-card-text>
    </v-card>

    <v-card flat class="mx-auto mt-3">
      <v-card-text class="pa-1 pl-3 pr-3 text-body-2 font-weight-bold">
        전체안내
      </v-card-text>
      <v-card-text class="pa-1 pl-3 pr-3 text-body-2">
        <p class="editorHtml" v-html="menu.all_upjang_notice || '-'"></p>
      </v-card-text>
    </v-card>

    <v-row v-if="!this.$vuetify.display.mobile" class="mt-5">
      <v-col cols="6" class="pl-0 pr-0">
        <v-card-actions class="justify-end">
          <v-btn size="large" class="w-50 text-body-2 bg-primary" @click="toCopy()">공유하기</v-btn>
        </v-card-actions>
      </v-col>
      <v-col cols="6" class="pl-0 pr-0">
        <v-card-actions class="justify-start">
          <v-btn size="large" class="w-50 text-body-2 bg-primary" @click="orderDialog = true">주문하기</v-btn>
        </v-card-actions>
      </v-col>
    </v-row>
  </v-card>

  <v-bottom-navigation v-if="this.$vuetify.display.mobile" class="bg-primary">
    <v-btn class="w-50 text-body-2" @click="toCopy()">공유하기</v-btn>
    <v-btn class="w-50 text-body-2" @click="orderDialog = true">주문하기</v-btn>
  </v-bottom-navigation>

  <v-dialog
      width="auto"
      height="auto"
      v-model="orderDialog"
      transition="dialog-bottom-transition">
    <v-card
        class="pa-2">
      <v-container class="pa-1" fluid>
        <v-row class="pa-0" justify="end">
          <v-btn
              class="pt-3 pr-3"
              icon
              @click="orderDialog = false"
              density="comfortable"
              variant="plain">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>

        <v-row class="pa-0">
          <v-col cols="12" class="pa-0">
            <v-card-title class="pt-0 font-weight-bold text-body-1">
              {{ menu.menu_name }}
            </v-card-title>
          </v-col>
        </v-row>

        <v-row class="align-center">
          <v-col cols="6" class="d-flex align-center">
            <v-btn icon
                   color="primary"
                   class="mr-2"
                   @click="decrement"
                   density="compact"
                   variant="outlined">
              <v-icon>mdi-minus</v-icon>
            </v-btn>
            <v-text-field
                v-model.number="menuCount"
                class="bg-white"
                density="compact"
                variant="outlined"
                type="number"
                min="2"
                :readonly=true
                single-line
                hide-details
            >
            </v-text-field>
            <v-btn icon
                   color="primary"
                   class="ml-2"
                   @click="increment"
                   density="compact"
                   variant="outlined">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="6" class="pl-0">
            <v-card-text class="pa-0 font-weight-bold text-body-1 text-end">
              {{ formatAmt(menu.sale_price) }}
            </v-card-text>
            <v-card-text v-if="menu.limit_yn === 'Y'" class="pa-0 text-caption text-end">
              (남은수량: {{menu.remain_cnt}}개)
            </v-card-text>
          </v-col>
        </v-row>

        <v-divider class="mt-5 mb-5"></v-divider>

        <v-card class="pa-2" color="grey-lighten-4" flat>
          <v-row class="ma-2">
            <v-card-text class="pa-0 font-weight-bold text-body-1 text-start">
              총 주문금액
            </v-card-text>
            <v-card-text class="pa-0 font-weight-bold text-body-1 text-end">
              {{ formatAmt(totalPrice) || '-' }}
            </v-card-text>
          </v-row>
        </v-card>

        <v-row class="mt-2">
          <v-col cols="6" class="pl-0 pr-0">
            <v-card-actions>
              <v-btn class="w-100" color="primary" variant="tonal" @click="updateAddedCartItem" :disabled="!isValidForm">장바구니</v-btn>
            </v-card-actions>
          </v-col>
          <v-col cols="6" class="pl-0 pr-0">
            <v-card-actions>
              <v-btn class="w-100" color="primary" variant="tonal" @click="goToCart" :disabled="!isValidForm">바로주문</v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>

</template>

<script>
import authStore from "@/store/auth";
import {cart, upjang} from "@/api";
import commonStore from "@/store/common";
import cartStore from "@/store/cart";
import {VueClipboard} from "@soerenmartius/vue3-clipboard";

export default {
  name: "MenuInfo",
  components: {VueClipboard},
  data() {
    return {
      isAuth: false,
      tags: [
        {
          title: '주문/구매',
          disabled: false,
          href: '/upjang',
        },
      ],
      menu: {},
      orderDialog: false,
      menuCount:0,
      menuPrice:0,
      totalPrice:0,
      menuCommentDtl: '-',
    }
  },
  created() {
    this.upjangCode = this.$route.params.upjangCode
    this.menuCode = this.$route.params.menuCode
    this.isAuth = authStore.state.authInfo.token !== null
    this.getMenu()
  },
  computed: {
    isValidForm() {
      return this.menuCount > 0
    }
  },
  methods: {
    getMenu() {
      upjang.getMenuInfo(commonStore.state.common.corpCode, this.upjangCode, this.menuCode)
          .then(data => {
            console.log(data)
            if (data.data) {
              this.menu = data.data
              this.tags.push({
                title: this.menu.upjang_name,
                disabled: false,
                href: '/upjang/' + this.menu.upjang_code,
              })
              if (this.menu.sale_price) {
                this.menuPrice = this.menu.sale_price
              }

              if (this.menu.menu_comment_dtl) {
                this.menuCommentDtl = this.menu.menu_comment_dtl
              }
              this.modifyImgStyles()
            }
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
    updateAddedCartItem() {
      if (cartStore.state.cart.upjangCode && cartStore.state.cart.upjangCode !== this.menu.upjang_code) {
        if (confirm("같은 업장의 상품만 담을 수 있습니다. 계속 진행하시게 되면 장바구니에 있는 상품들이 없어집니다.\n계속 하시겠습니까?") === true){
          cartStore.dispatch('removeCartInfo')
        }else{
          return
        }
      }

      cart.updateAddedCartItem(
          commonStore.state.common.corpCode, this.upjangCode, this.menuCode,
          this.menuCount, cartStore.state.cart.cartKey
      )
          .then(data => {
            console.log(data)
            if (data.data) {
              if (data.data.cart_key) {
                console.log('this.upjangCode', this.upjangCode)
                cartStore.dispatch('setCartInfo', {
                  cartKey: data.data.cart_key,
                  upjangCode: this.upjangCode
                })
                alert("장바구니에 담겼습니다.")
                this.$router.push('/upjang/' + this.menu.upjang_code)
              }
            }
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
    goToCart() {
      if (cartStore.state.cart.upjangCode && cartStore.state.cart.upjangCode !== this.menu.upjang_code) {
        if (confirm("같은 업장의 상품만 주문할 수 있습니다. 계속 진행하시게 되면 장바구니에 있는 상품들이 없어집니다.\n계속 하시겠습니까?") === true){
          cartStore.dispatch('removeCartInfo')
        }else{
          return
        }
      }

      cart.updateAddedCartItem(
          commonStore.state.common.corpCode, this.upjangCode, this.menuCode,
          this.menuCount, cartStore.state.cart.cartKey
      )
          .then(data => {
            console.log(data)
            if (data.data) {
              if (data.data.cart_key) {
                console.log('this.upjangCode', this.upjangCode)
                cartStore.dispatch('setCartInfo', {
                  cartKey: data.data.cart_key,
                  upjangCode: this.upjangCode
                })

                this.$router.push('/cart')
              }
            }
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
    toCopy() {
      VueClipboard.toClipboard(process.env.VUE_APP_URL + window.location.pathname, 'copy')
      alert("클립보드에 복사되었습니다.")
    },
    increment () {
      if (this.menu.limit_yn === 'Y' && (this.menuCount >= this.menu.remain_cnt)) {
        alert("구매 가능한 수량이 없습니다.\n더 이상 상품을 추가할 수 없습니다.")
        return
      }
      this.menuCount = parseInt(this.menuCount,10) + 1
      this.totalPrice = this.menuPrice * this.menuCount
    },
    decrement () {
      if (this.menuCount === 0) {
        return
      }
      this.menuCount = parseInt(this.menuCount,10) - 1
      this.totalPrice = this.menuPrice * this.menuCount
    },
    modifyImgStyles() {
      this.$nextTick(() => {
        const imgTags = document.querySelectorAll('.editorHtml img');
        imgTags.forEach((img) => {
          img.style.width = '100%';
        });
      });
    },
  }
}
</script>

<style scoped>
/deep/ .v-field__input { padding: 8px; text-align: center; }
</style>